import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {TmStatusEnum} from "../../../../enum/tm-status.enum";
import {TicketService} from "../../../../service/api/ticket.service";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
// TODO Dependency
// TODO Dependency


@Component({
    selector: 'mvs-example',
    templateUrl: 'tm-statistics.component.html',
    standalone: false
})
export class TmStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {


    assignedTickets: number = 0;
    workingTickets: number = 0;
    cancelledTickets: number = 0;
    onHoldTickets: number = 0;

    ticketHistoryWidget: WidgetData;
    ticketStatusWidget: WidgetData;
    ticketUrgencyWidget: WidgetData;
    recentlyAddedTicketWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        protected ticketService: TicketService,
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {

        this.items = [
            {label: 'Ticket Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.getTotalResolvedTickets();
        this.refreshTicketHistoryWidget();
        this.refreshTicketStatusWidgets();
        this.refreshTicketTypeGroupWidgets();
        this.refreshAddedTicketsWidget();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/tm/config']);
    }


    getTotalResolvedTickets() {
        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            this.filterCriteria,
            [],
            ['status'],
            [new ObjectRequestListAttribute('status', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.ticketService.groupBy(objectRequestList).subscribe(res => {
            this.overviewDto = [
                { label: 'Assigned Tickets', value: 0 },
                { label: 'Working Tickets', value: 0 },
                { label: 'Cancelled Tickets', value: 0 },
                { label: 'On-hold Tickets', value: 0 }
            ];

            for (let entry of res.entries) {
                if (entry['status'] === TmStatusEnum.assigned) {
                    this.overviewDto.find(item => item.label === 'Assigned Tickets').value = entry['status_count'];
                } else if (entry['status'] === TmStatusEnum.working) {
                    this.overviewDto.find(item => item.label === 'Working Tickets').value = entry['status_count'];
                } else if (entry['status'] === TmStatusEnum.cancelled) {
                    this.overviewDto.find(item => item.label === 'Cancelled Tickets').value = entry['status_count'];
                } else if (entry['status'] === TmStatusEnum.on_hold) {
                    this.overviewDto.find(item => item.label === 'On-hold Tickets').value = entry['status_count'];
                }
            }

        });
    }


    refreshTicketHistoryWidget() {
        this.ticketHistoryWidget = WidgetFactory.createWidget(
            'tm.ticket.overview.ticket.history.widget',
            'Ticket History',
            'history.chart',
            'list',
            'entity.groupBy',
            'tm.Ticket',
            WidgetDataParam.create("fieldCategory", "type"),
            WidgetDataParam.create("fieldCategoryCount", "type_count"),
            WidgetDataParam.create("historyPeriodMode", "year"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.ticketHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["type", "createdDate"],
            [new ObjectRequestListAttribute("type", "Anzahl", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshTicketStatusWidgets() {
        this.ticketStatusWidget = WidgetFactory.createWidgetGroupBy(
            'tm.ticket.overview.ticket.status.widget',
            'Ticket Groups',
            'category',
            'entity.groupBy',
            'tm.Ticket',
            'status',
            'status_count',
            this.filterCriteria,
            'status',
            'Anzahl');
    }

    refreshTicketTypeGroupWidgets() {
        this.ticketUrgencyWidget = WidgetFactory.createWidgetGroupBy(
            'tm.ticket.overview.ticket.urgency.widget',
            'Ticket Urgency',
            'category',
            'entity.groupBy',
            'tm.Ticket',
            'urgency',
            'urgency_count',
            this.filterCriteria,
            'urgency',
            'Anzahl');
    }

    refreshAddedTicketsWidget() {
        this.recentlyAddedTicketWidget = WidgetFactory.createWidgetTableEntityBasicQl('tm.ticket.overview.recently.added.tickets', 'Recently Added Tickets', 'tm.Ticket', this.filterCriteriaForQuery, [new Sorting('e.createdDate', false)])
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
